
/**
 * ProcessedElement class
 */
export default class ProcessedElement {
  /**
   * constructor processed elem
   * @param {*} elem
   * @param {*} position
   */
  constructor(elem, position) {
    this.elem = elem;
    this.pos = position;
  }
}
